var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8916_12181)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.634277,
    width: 40,
    height: 40,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8904 13.5607L23.0895 14.0328C22.9569 14.0488 22.9026 14.2096 22.9951 14.304L24.0939 15.4029L21.0102 18.4866C20.9803 18.5168 20.9635 18.5576 20.9635 18.6001C20.9635 18.6426 20.9803 18.6834 21.0102 18.7136L21.9163 19.6196C21.9785 19.6819 22.081 19.6819 22.1433 19.6196L25.229 16.5339L26.3279 17.6328C26.3491 17.654 26.3758 17.6688 26.405 17.6754C26.4343 17.6821 26.4648 17.6805 26.4931 17.6706C26.5214 17.6607 26.5463 17.6431 26.5651 17.6197C26.5838 17.5963 26.5956 17.5681 26.5991 17.5384L27.0692 13.7395C27.0725 13.7152 27.0702 13.6905 27.0624 13.6673C27.0545 13.6441 27.0415 13.623 27.0242 13.6057C27.0068 13.5884 26.9858 13.5753 26.9625 13.5675C26.9393 13.5597 26.9146 13.5573 26.8904 13.5607ZM18.0832 21.6406C18.053 21.6107 18.0122 21.5939 17.9697 21.5939C17.9272 21.5939 17.8864 21.6107 17.8562 21.6406L14.7725 24.7263L13.6736 23.6274C13.6524 23.6062 13.6257 23.5914 13.5965 23.5848C13.5672 23.5781 13.5367 23.5797 13.5084 23.5896C13.4801 23.5995 13.4552 23.6171 13.4364 23.6405C13.4177 23.6639 13.4059 23.6921 13.4024 23.7218L12.9303 27.5207C12.9183 27.6252 13.0047 27.7116 13.1091 27.6995L16.91 27.2274C17.0426 27.2113 17.0968 27.0506 17.0044 26.9562L15.9055 25.8573L18.9913 22.7716C19.0535 22.7093 19.0535 22.6069 18.9913 22.5446L18.0832 21.6406Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.13428,
    width: 39,
    height: 39,
    rx: 1.5,
    stroke: "#DEDCDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8916_12181",
    x: 0,
    y: 0.634277,
    width: 40,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.016 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8916_12181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8916_12181",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.4355a3efb1cdd2906fff717828cb4585.svg";
export { ForwardRef as ReactComponent };